import { CompanyBlackList, CompanyBlackListDto, CompanyList, IResponsePaginate } from '@/types';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompanyBlackListService {
  httpClient = inject(HttpClient);
  BASEURL = `${environment.api.paramsUrl}/societe`;

  getCompanies(): Observable<CompanyList[]> {
    return this.httpClient.get<CompanyList[]>(`${this.BASEURL}/all-validee-list`);
  }

  create(company: CompanyBlackListDto): Observable<any> {
    return this.httpClient.post<any>(`${this.BASEURL}/blacklist`, company);
  }

  getBlackListedCompanies(): Observable<IResponsePaginate<CompanyBlackList>> {
    return this.httpClient.get<IResponsePaginate<CompanyBlackList>>(`${this.BASEURL}/blacklist`);
  }

  update(id: number, company: CompanyBlackListDto): Observable<any> {
    return this.httpClient.put<any>(`${this.BASEURL}/blacklist/${id}`, company);
  }
}
